import { apiLogout } from 'app/api/users/auth';

import { logout, logoutStart } from '../../auth';
import { AppThunk } from '../../index';

export const logoutUser =
  (forceNoRedirect?: boolean): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(logoutStart());
      await apiLogout();
      dispatch(logout(forceNoRedirect));
    } catch (err: any) {
      console.error(err.toString());
    }
  };
